import { render, staticRenderFns } from "./standardGap.vue?vue&type=template&id=e4b7d724&scoped=true"
import script from "./standardGap.vue?vue&type=script&lang=js"
export * from "./standardGap.vue?vue&type=script&lang=js"
import style0 from "./standardGap.vue?vue&type=style&index=0&id=e4b7d724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b7d724",
  null
  
)

export default component.exports